import { PUBLIC_SERVER_ENDPOINT } from '$env/static/public';
export class Base {
	constructor(token) {
		this.token = token;
	}

	async get(url) {
		const fullurl = PUBLIC_SERVER_ENDPOINT + url;
		const response = await fetch(fullurl, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Bearer ' + this.token
			}
		});
		try {
			let parsed_response
			if (response.status>=200 && response.status<300){
				 parsed_response= response.json();
			} else {
				parsed_response = {"status_code":response.status,"status":response.statusText}

			}
			return parsed_response;
		} catch (error) {
			//TODO: Push error to sentry
			return {};
		}
	}
	async delete(url) {
		const fullurl = PUBLIC_SERVER_ENDPOINT + url;
		const response = await fetch(fullurl, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Bearer ' + this.token
			}
		});
		return response.json();
	}

	async post(url, body_map) {
		const fullurl = PUBLIC_SERVER_ENDPOINT + url;

		const response = await fetch(fullurl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Bearer ' + this.token
			},
			body: JSON.stringify(body_map)
		});
		try {
			const parsed_response = response.json();
			return parsed_response;
		} catch (error) {
			//TODO: Push error to sentry
			return {};
		}

		// return response.json();
	}
	async postraw(url, body_map) {
		const fullurl = PUBLIC_SERVER_ENDPOINT + url;

		const response = await fetch(fullurl, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Bearer ' + this.token
			},
			body: JSON.stringify(body_map)
		});
		return response;
	}
	async put(url, body_map) {
		const fullurl = PUBLIC_SERVER_ENDPOINT + url;

		const response = await fetch(fullurl, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				Authorization: 'Bearer ' + this.token
			},
			body: JSON.stringify(body_map)
		});
		return response.json();
	}
}
